import { messages } from '../../../i18n';

const getAspectRatioOptions = (intl) => {

	return [
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_21_BY_9
			),
			value: '21by9',
		},
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_2_BY_1
			),
			value: '2by1',
		},
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_16_BY_9
			),
			value: '16by9',
		},
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_5_BY_4
			),
			value: '5by4',
		},
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_4_BY_3
			),
			value: '4by3',
		},
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_1_BY_1
			),
			value: '1by1',
		}
	];

};

const getLinkTargetOptions = (intl) => {

	return [
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_LINK_TARGET_LABEL_TEXT_NEW_WINDOW,
			),
			value: '_blank',
		},
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_LINK_TARGET_LABEL_TEXT_NONE,
			),
			value: '_self',
		}
	];

};

const getWidthOptions = (intl) => {

	return [
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_FULL
			),
			value: '12',
		},
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_THREE_FOURTHS,
			),
			value: '9',
		},
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_TWO_THIRDS
			),
			value: '8',
		},
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_HALF
			),
			value: '6',
		},
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_ONE_THIRD
			),
			value: '4',
		},
		{
			label: intl.formatMessage(
				messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_ONE_FOURTH
			),
			value: '3',
		}
	];

};

export {
	getAspectRatioOptions,
	getLinkTargetOptions,
	getWidthOptions,
};
